var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExitFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 10.5a.75.75 0 010-1.5h5A.25.25 0 009 8.75v-5a.75.75 0 011.5 0v5a1.75 1.75 0 01-1.75 1.75h-5zM3.75 13.5a.75.75 0 000 1.5h5a.25.25 0 01.25.25v5a.75.75 0 001.5 0v-5a1.75 1.75 0 00-1.75-1.75h-5zM20.25 10.5a.75.75 0 000-1.5h-5a.25.25 0 01-.25-.25v-5a.75.75 0 00-1.5 0v5c0 .966.784 1.75 1.75 1.75h5zM20.25 13.5a.75.75 0 010 1.5h-5a.25.25 0 00-.25.25v5a.75.75 0 01-1.5 0v-5c0-.966.784-1.75 1.75-1.75h5z",
    fill: "currentColor"
  })));
}
SvgExitFullscreen.displayName = 'ExitFullscreen';
export default SvgExitFullscreen;